import { render } from "./createSubSection.vue?vue&type=template&id=6e08cee6"
import script from "./createSubSection.vue?vue&type=script&lang=js"
export * from "./createSubSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/public_web/selllogix-vuecli/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__